/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		fetch(this.dataset.url + '&t=' + Date.now())
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					// Ikiša fiksuotas prekes (data-pinned) i atsitiktine pozicija
					this.randomizePinned();

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}

				}

				this.classList.add('product-recommendations--loaded');

			})
			.catch(e => {
				console.error(e);
			});
	}
	randomizePinned() {
		const list = this.querySelector('ul.products');
		if (!list) return;

		// Surenkam fiksuotas prekes (data-pinned) ir likusias rekomendacijas
		const pinned = Array.from(list.querySelectorAll(':scope > li[data-pinned]'));
		if (!pinned.length) return;
		const recs = Array.from(list.querySelectorAll(':scope > li:not([data-pinned])'));

		const total = recs.length + pinned.length;

		// Parenkam tiek skirtingu poziciju, kiek fiksuotu prekiu (0 .. total-1)
		const allPos = Array.from({ length: total }, (_, i) => i);
		for (let i = allPos.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[allPos[i], allPos[j]] = [allPos[j], allPos[i]];
		}
		const pinnedPositions = allPos.slice(0, pinned.length).sort((a, b) => a - b);

		// Perstatom sarasa is naujo
		list.innerHTML = '';
		let recI = 0, pinI = 0;
		for (let pos = 0; pos < total; pos++) {
			if (pinI < pinnedPositions.length && pinnedPositions[pinI] === pos) {
				list.appendChild(pinned[pinI]);
				pinI++;
			} else if (recI < recs.length) {
				list.appendChild(recs[recI]);
				recI++;
			}
		}
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);